export default __webpack_public_path__ + "styles/CustomFormUI.a1ba7da05d6c63d52a358e32bcfb8217.css";